module.exports = __webpack_public_path__ + "static/img/00.7b64e32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/commodity/01/00.jpg
// module id = GZMv
// module chunks = 0